import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

export type SignedUrlDTO = {
  agent_id: string;
};

export type SignedUrlResponse = {
  signedUrl: string;
};

export const getSignedUrl = ({ agent_id }: SignedUrlDTO): Promise<SignedUrlResponse> => {
  return axios.get('/chatbot/conversation/url', {
    params: { agent_id },
  });
};

type UseSignedUrlOptions = {
  config?: MutationConfig<typeof getSignedUrl>;
};

export const useGetSignedUrl = ({ config }: UseSignedUrlOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getSignedUrl,
  });
};
